import React from 'react';
import Heading from '../Headers/Heading';
import ServiceBox from './ServiceBox';
import { ServicesData } from '../../Data/ServicesData';

function ServicesSection(props) {
    return (
        <div className="services section-padding" style={{ background: '#fff' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                         <Heading 
                            heading={<h2>Our Rehabilitation Programs</h2>}
                            headingClass="heading-large dark-1 text-center mb-5"
                            headingColumn="col-12"
                        />
                    </div>
                </div>
                <div className="row">
                    {ServicesData.map((service, index) => (
                        <div className="col-lg-4 col-md-6 mb-4" key={index}>
                            <ServiceBox 
                                icon={service.icon}
                                title={service.title}
                                paragraph={service.paragraph} // Ensure ServiceBox supports paragraph if added
                            />
                        </div>
                    ))}
                </div>
                {!props.hideButton && (
                <div className="row mt-4">
                    <div className="col-12 text-center">
                        <a href="/programs" className="button button-1">View All Programs</a>
                    </div>
                </div>
                )}
            </div>
        </div>
    );
}

export default ServicesSection;
